// Packages and components
import React from 'react';
import { MoonLoader } from 'react-spinners';

// Helpers and utlities
import theme from '@theme/sbot.theme';

// Types
import type { SHDLoaderProps } from './SHDLoader.d';

const SHDLoader: React.FC<SHDLoaderProps> = ({
  className = 'loader',
  color = 'brand',
  size = 36,
}) => {
  const getSpinnerColor = () => {
    const themeColor = theme.global.colors[color];
    if (!themeColor) {
      return '#000000';
    }
    return themeColor;
  };

  return (
    <MoonLoader
      role="status"
      className={className}
      size={size}
      color={getSpinnerColor()}
    />
  );
};

export default SHDLoader;
